require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default() {
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, _react["default"].createElement("path", {
    d: "M34.172 18.75h-5.004v-4.168c0-2.148.172-3.504 3.254-3.504h1.808a2.085 2.085 0 0 0 2.086-2.082V6.383c0-1.09-.836-2.02-1.925-2.094a53.072 53.072 0 0 0-3.782-.121c-5.652 0-9.777 3.45-9.777 9.789v4.793h-4.164a2.085 2.085 0 0 0-2.086 2.082V25c0 1.148.934 2.082 2.086 2.082h4.164V43.75c0 1.148.934 2.082 2.086 2.082h4.164a2.085 2.085 0 0 0 2.086-2.082V27.078l4.527-.004c1.059 0 1.95-.793 2.07-1.844l.477-4.16a2.082 2.082 0 0 0-2.07-2.32zm0 0"
  }));
};

exports["default"] = _default;